/**
 * Extracts the first JSON object from a string by finding the outermost `{` and `}`.
 * Returns empty string if no valid brackets found, so JSON.parse() will throw a clear error.
 */
export function stripBeforeAndAfterBrackets(str: string): string {
  const start = str.indexOf('{');
  const end = str.lastIndexOf('}');

  if (start === -1 || end === -1 || start > end) {
    return '';
  }

  return str.substring(start, end + 1);
}
